import { useEffect, useRef, useState } from 'react'
import { useMainNavigationDispatch } from '@/providers/mainNavigationMenuProvider'
import { genderCategoryMap } from '@/components/organisms/toolbar/desktop/campaignNavigationLinks'
import type { NavigationItem } from '@/network/graphql.g'

export enum MainCategoryId {
  Accessories = '112',
  Sports = '719'
}

export const lastVisitedMainCategoryKey = 'lastVisitedMainCategory'

const useCurrentMainCategoryId = (
  navigationItems: NavigationItem[]
): string => {
  const { slugPath } = useMainNavigationDispatch()
  const [lastVisitedMainCategory, setLastVisitedMainCategory] = useState<
    string | null
  >(() => {
    if (typeof window === 'undefined') {
      return null
    }
    try {
      return localStorage.getItem(lastVisitedMainCategoryKey)
    } catch {
      return null
    }
  })
  useEffect(() => {
    if (lastVisitedMainCategory === null) {
      try {
        const storedId = localStorage.getItem(lastVisitedMainCategoryKey)
        if (storedId) {
          setLastVisitedMainCategory(storedId)
        }
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }, [lastVisitedMainCategory])

  const prevMainIdRef = useRef<string | null>(null)

  const currentMainCategory = navigationItems
    ?.filter(({ isMainCategory }) => isMainCategory)
    .find(({ categoryId }) => slugPath.some((p) => p.id === categoryId))

  const isSlugResolved =
    Array.isArray(slugPath) &&
    slugPath.length > 0 &&
    !!currentMainCategory?.categoryId

  const currentMainCategoryId =
    (isSlugResolved && currentMainCategory?.categoryId) ||
    lastVisitedMainCategory ||
    prevMainIdRef.current ||
    genderCategoryMap.women

  useEffect(() => {
    if (currentMainCategory?.categoryId) {
      prevMainIdRef.current = currentMainCategory.categoryId
    } else if (lastVisitedMainCategory) {
      prevMainIdRef.current = lastVisitedMainCategory
    }
  }, [currentMainCategory?.categoryId, lastVisitedMainCategory])

  return currentMainCategoryId
}
export default useCurrentMainCategoryId
